import { render } from "./Alliance.vue?vue&type=template&id=d47c14a2&scoped=true"
import script from "./Alliance.vue?vue&type=script&lang=js"
export * from "./Alliance.vue?vue&type=script&lang=js"

import "./Alliance.vue?vue&type=style&index=0&id=d47c14a2&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d47c14a2"]])

export default __exports__